export default __webpack_public_path__ + "static/media/background-1.f882197e.png";